<template>
    <v-view :tableData="tableData"
            :tableProps="tableProps"
            :modalProps="modalProps"
            :columns="columns"
            :routes="routes"
            :initialSort="initialSort"
            :buttonsVisibility="buttonsVisibility"
            :rowButtonAction="rowButtonAction"
            v-model:selectedRows="selectedRows">

        <template #crud="formProps">
            <ScaleForm :formProps="formProps">
            </ScaleForm>
        </template>
        <template #search="searchProps">
            <ScaleSearch :searchProps="searchProps">
            </ScaleSearch>
        </template>

    </v-view>
</template>

<script setup>
import ScaleForm from './ScaleForm.vue'
import ScaleSearch from './ScaleSearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

//------------------------------------------------------------------------------

</script>

<style lang="scss"
       scoped></style>
